import React from "react";
import { useNavigate } from "react-router-dom";
import "./challengeCard.style.scss";

const ChallengeCard = ({
    id, imageURL,
    title, eventTime,
    eventsTotal, weeks, onClick,
    videoURL
}) => {

    return (
        <div>
            <div style={{
                backgroundImage: `url(${imageURL})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '200px',
                borderRadius: '10px',
                cursor: 'pointer'
            }}
                onClick={() => onClick(id)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.filter = 'grayscale(0%) brightness(105%)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.filter = 'none';
                }}
            >
            </div>
            <div style={{
                marginTop: '4px',
                display: 'flex',
                gap: '8px',
                alignItems: 'center'
            }}>
                <h4 style={{
                    marginTop: '4px',
                    marginBottom: '4px',
                    cursor: 'pointer',
                    width: 'fit-content'
                }}
                    onClick={() => onClick(id)}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#454545';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = 'black';
                    }}
                >
                    {title}
                </h4>
                {videoURL !== null && videoURL !== "" ? (
                    <p style={{
                        width: '30%',
                        marginRight: '4px',
                        marginLeft: 'auto',
                        color: '#3286f3',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textAlign: "right",
                        fontSize: 'smaller',
                        marginTop: '4px',
                        marginBottom: '4px',
                    }}
                        onClick={() => window.open(videoURL, '_blank')}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.color = '#8dbbf7';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.color = '#3286f3';
                        }}
                    >video</p>
                ) : null}
            </div>
            <div style={{ display: "flex", gap: '4px' }}>
                <p style={{
                    fontSize: 'smaller',
                    marginTop: '4px',
                    marginBottom: '4px',
                    color: 'rgb(77, 77, 77)'
                }}
                ><strong>{eventTime} · {eventsTotal} events · {weeks} weeks</strong></p>
            </div>
        </div>
    );
};

export default ChallengeCard;